/**
 * Recursively trims leading/trailing whitespace from every string in a value.
 * Objects and arrays are copied; non-string leaves (numbers, booleans, null, Dates) are returned as-is.
 */
export function trimStrings<T>(value: T): T {
  if (typeof value === 'string') {
    return value.trim() as unknown as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => trimStrings(item)) as unknown as T;
  }
  if (value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, v]) => [key, trimStrings(v)])
    ) as T;
  }
  return value;
}
